import { render, staticRenderFns } from "./ZoneForm.vue?vue&type=template&id=f8fe4bf8&scoped=true&"
import script from "./ZoneForm.vue?vue&type=script&lang=js&"
export * from "./ZoneForm.vue?vue&type=script&lang=js&"
import style0 from "./ZoneForm.vue?vue&type=style&index=0&id=f8fe4bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fe4bf8",
  null
  
)

export default component.exports